import { Component } from '@angular/core';
import {finalize} from 'rxjs/operators';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalDismissReasons, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ShoppingModel} from '../../models/shopping.model';
import {ShoppingPromotionModel} from '../../models/shopping-promotion.model';
import {ScratchModel, ScratchStatus} from '../../models/scratch.model';
import {ChainService} from '@app/chain/chain.service';
import {DomainService} from '@app/core/domain/domain.service';
import {PlaceServiceBase} from '@app/core/places.service';

@Component({
  selector: 'app-shopping-cupons',
  templateUrl: './shopping-scratches.component.html',
  styleUrls: ['./shopping-scratches.component.scss']
})
export class ShoppingScratchesComponent {
  shopping: ShoppingModel;
  scratches: ScratchModel[];
  filteredScratches: ScratchModel[];
  selectedItem: ScratchModel;
  modalReference: NgbModalRef;
  loadingScratch = true;
  isLoadingList = true;
  onlyAvailable = true;
  contentScratched: any;
  qrcode: string = null;

  placeService: PlaceServiceBase;
  isShoppingDomain: boolean;

  constructor(private shoppingService: ShoppingService,
              private chainService: ChainService,
              private domainService: DomainService,
              private route: ActivatedRoute,
              private modalService: NgbModal,
              private router: Router) {
    this.isShoppingDomain = domainService.isShoppingDomain();
    this.placeService = this.isShoppingDomain ? shoppingService : chainService;
    this.route.params.subscribe( params => {
      this.loadShoppingScratches(params.shoppingId);
    } );
  }

  setFilter(onlyAvailable: boolean) {
    this.onlyAvailable = onlyAvailable;
    if (this.onlyAvailable) {
      this.filteredScratches = this.scratches.filter(scratch => scratch.status !== ScratchStatus.SCRATCHED);
    } else {
      this.filteredScratches = this.scratches.filter(scratch => scratch.status === ScratchStatus.SCRATCHED);
    }
  }

  navbarLeftText() {
    return `${(this.scratches ? this.scratches.length : 0)} Cupons raspáveis digitais`;
  }

  getImageBackground(scratch: ScratchModel) {
    let url = '/assets/raspadinhabg.png';
    if (scratch.contemplated && !this.onlyAvailable) {
      url = '/assets/raspadinhaitembg_green.png';
    }
    return `url(\"${url}\") center no-repeat`;
  }

  getGiftImage(scratch: ScratchModel) {
    return `url(\"${scratch.gift.image}\") center no-repeat`;
  }

  getImage(scratch: ScratchModel) {
    return `url(\"${scratch.campaignImage}\") center no-repeat`;
  }

  getImageScratch(scratch: ScratchModel) {
    return `url(\"${scratch.scratchImage}\")`;
  }

  loadShoppingScratches(shoppingId: string) {
    this.isLoadingList = true;
    this.placeService.getShopping(shoppingId)
      .pipe(finalize(() => {
      }))
      .subscribe(shopping => {
        this.shopping = shopping;
        this.isLoadingList = false;
      }, error => {
        console.log(`shopping error: ${error}`);
      });

    this.placeService.getScratches(shoppingId)
      .pipe(finalize(() => {
      }))
      .subscribe(scratches => {
        this.scratches = scratches;
        this.setFilter(true);
      }, error => {
        console.log(`shopping error: ${error}`);
      });
  }

  openModal(content: any, item: ScratchModel) {
    this.loadingScratch = false;
    this.selectedItem = item;
    this.qrcode = btoa(JSON.stringify({
      contemplated: this.selectedItem.contemplated,
      id_hash: this.selectedItem.id_hash
    }));
    this.modalReference = this.modalService.open(content, { windowClass: 'modal-centered modal-md' });
 }

  openScratch(content: any, item: ScratchModel, contentScratched: any) {
    console.log('abrindo raspadinha...');
    this.ct = false;
    this.selectedItem = item;
    this.loadingScratch = true;
    this.contentScratched = contentScratched;
    this.placeService.updateScratche(this.selectedItem)
      .pipe(finalize(() => {
        this.loadingScratch = false;
        console.log('desligando o loading...');
        this.setCanvas();
      }))
      .subscribe(scratche => {
        this.selectedItem = scratche;
      }, error => {
        console.log(`shopping error: ${error}`);
      });
      this.selectedItem.status = ScratchStatus.VIZUALIZED;
      this.modalReference = this.modalService.open(content, { windowClass: 'modal-centered modal-md' });
      this.modalReference.result.then((result) => {
        this.loadShoppingScratches(this.shopping.id_hash);
      }, (reason) => {
        this.loadShoppingScratches(this.shopping.id_hash);
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  updateStatusScratche(status: number, comp: ShoppingScratchesComponent) {
    console.log('atualizando...');
    if (comp.selectedItem.status !== status) {
      comp.selectedItem.status = status;
      comp.shoppingService.updateScratche(comp.selectedItem)
        .pipe(finalize(() => {
          comp.loadingScratch = false;
        }))
        .subscribe(scratche => {
          comp.selectedItem = scratche;
          if (comp.selectedItem.status === ScratchStatus.SCRATCHED) {
            comp.modalReference.dismiss();
            comp.modalReference = this.modalService.open(comp.contentScratched, {
              windowClass: 'modal-centered modal-md'
            });
            comp.modalReference.result.then((result) => {
              comp.loadShoppingScratches(this.shopping.id_hash);
            }, (reason) => {
              comp.loadShoppingScratches(this.shopping.id_hash);
            });

          }
        }, error => {
          console.log(`shopping error: ${error}`);
        });
    }
  }

  finishScratch(comp: ShoppingScratchesComponent) {
    comp.loadingScratch = true;
    comp.updateStatusScratche(ScratchStatus.SCRATCHED, comp);
  }

  ct = false;

  setCanvas() {
    if (!this.loadingScratch && !this.ct) {
      console.log('criando canvas');
      const that = this;
      setTimeout(function () {
        that.createCanvas();
      }, 500 );
    }
    return true;
  }

  createCanvas() {
    if (this.ct) {
      return;
    }
    this.ct = true;
    let finishScratch = this.finishScratch;
    let component = this;
    let updateStatus = this.updateStatusScratche;
    let canvas = <HTMLCanvasElement> document.getElementById('js-canvas');
    let isDrawing = false;
    let isStartScratch = false;
    let lastPoint: any;
    let container    = document.getElementById('js-container');
    let imgGift    = <HTMLImageElement> document.getElementById('img_gift');
    let canvasWidth  = canvas.width;
    let canvasHeight = canvas.height;
    let ctx = canvas.getContext('2d');
    let image        = new Image();
    let brush        = new Image();
    brush.crossOrigin = 'Anonymous';
    canvas.width = container.clientWidth;
    canvas.height = container.clientHeight;

    if (this.selectedItem.status != ScratchStatus.SCRATCHED) {
      imgGift.src =  this.selectedItem.scratchImage ;
      image.crossOrigin = 'Anonymous';
      image.src =  ' data:image/jpeg;base64,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';
      image.width = canvas.width;
      image.height = canvas.height;
      image.onload = function() {
        console.log('desenhando imagem...');
        ctx.drawImage(image, 0, 0, canvasWidth, canvasHeight);
      };

    } else {
      imgGift.src =  this.selectedItem.gift.image ;
    }

    brush.src = '/assets/scratch.png';
    canvas.addEventListener('mousedown', handleMouseDown, false);
    canvas.addEventListener('touchstart', handleMouseDown, false);
    canvas.addEventListener('mousemove', handleMouseMove, false);
    canvas.addEventListener('touchmove', handleMouseMove, false);
    canvas.addEventListener('mouseup', handleMouseUp, false);
    canvas.addEventListener('touchend', handleMouseUp, false);

    function distanceBetween(point1: any, point2: any) {
      return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
    }

    function angleBetween(point1: any, point2: any) {
      return Math.atan2( point2.x - point1.x, point2.y - point1.y );
    }

    // Only test every `stride` pixel. `stride`x faster,
    // but might lead to inaccuracy
    function getFilledInPixels(stride: any) {
      if (!stride || stride < 1) { stride = 1; }

      let pixels   = ctx.getImageData(0, 0, canvasWidth, canvasHeight),
        pdata    = pixels.data,
        l        = pdata.length,
        total    = (l / stride),
        count    = 0;

      // Iterate over all pixels
      for (let i = count = 0; i < l; i += stride) {
        if (pdata[i] === 0) {
          count++;
        }
      }

      return Math.round((count / total) * 100);
    }

    function getMouse(e: any, canvas: any) {
      let offsetX = 0, offsetY = 0, mx, my;

      if (canvas.offsetParent !== undefined) {
        do {
          offsetX += canvas.offsetLeft;
          offsetY += canvas.offsetTop;
        } while ((canvas = canvas.offsetParent));
      }

      mx = (e.pageX || e.touches[0].clientX) - offsetX;
      my = (e.pageY || e.touches[0].clientY) - offsetY;

      return {x: mx, y: my};
    }

    function handlePercentage(filledInPixels: any) {
      filledInPixels = filledInPixels || 0;
      console.log(filledInPixels + '%');
      if (!isStartScratch && filledInPixels > 10) {
        isStartScratch = true;
        updateStatus(ScratchStatus.SCRATCHING, component);
      }
      if (filledInPixels > 75) {
        canvas.parentNode.removeChild(canvas);
        finishScratch(component);
      }
    }

    function handleMouseDown(e: any) {
      isDrawing = true;
      lastPoint = getMouse(e, canvas);
    }

    function handleMouseMove(e: any) {
      if (!isDrawing) { return; }

      e.preventDefault();

      let currentPoint = getMouse(e, canvas),
        dist = distanceBetween(lastPoint, currentPoint),
        angle = angleBetween(lastPoint, currentPoint),
        x, y;

      for (let i = 0; i < dist; i++) {
        x = lastPoint.x + (Math.sin(angle) * i) - 25;
        y = lastPoint.y + (Math.cos(angle) * i) - 25;
        ctx.globalCompositeOperation = 'destination-out';
        ctx.drawImage(brush, x, y);
      }

      lastPoint = currentPoint;
      handlePercentage(getFilledInPixels(32));
    }

    function handleMouseUp(e: any) {
      isDrawing = false;
    }
  }




}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-scratches/shopping-scratches.component.ts